import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { Subscription, filter } from 'rxjs';
import { MessageService, ToastMessageOptions } from 'primeng/api';

import { AttributeModel } from '../../models/attribute.model';
import { attributeTypesEnum } from '../../enums/attribute-types.enum';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { copy } from '../../helpers/copy/copy.helper';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { messageSeverityEnum } from '../../enums/message-severity.enum';
import { PreferencesModel } from '../../../../Core/Users/models/preferences.model';
import { TimeZoneFormatEnum } from '../../enums/time-zone-format.enum';


@Component({
    selector: 'agpr-attribute-list',
    templateUrl: './attribute-list.component.html',
    styleUrls: ['./attribute-list.component.scss'],
    standalone: false
})
export class AttributeListComponent implements OnInit, OnDestroy {
    public readonly attributeTypes = attributeTypesEnum;
    public readonly buttonTypes = ButtonTypesEnum;
    private subscriptions: Subscription[] = [];
    public readonly defaultTimeFormat = TimeZoneFormatEnum.timeZoneFormat;
    public readonly offsetTimeFormat = TimeZoneFormatEnum.timeZoneOffsetFormat;

    public usersMap: {[key: number]: string} = [];
    public preferences: PreferencesModel;
    dateFormat: string;

    @Input() attributes: AttributeModel[] = null;
    @Input() showFullLengthTooltip: boolean = false;
    @Input() isLoading: boolean = false;
    @Input() isGrid: boolean = false;
    @Input() id: string;

    constructor(
        private currentUserService: CurrentUserStateService,
        private messageService: MessageService,
        private localizationService: LocalizationService,
        @Inject (APP_BASE_HREF) public appBaseHref: string
    ) { }


    ngOnInit(): void {
        this.subscriptions.push(
            this.currentUserService.getAccountUsers().subscribe(
                users => {
                    this.usersMap = {};

                    if (users) {
                        users.forEach(user => {
                            this.usersMap[user.id] = user.getDisplayName();
                        });
                    }
                }
            ),
            this.currentUserService.getPreferences().pipe(filter(x => !!x)).subscribe(
                prefs => this.preferences = prefs
            )
        );
    }

    copyUrl(event: Event, url: string, message?: ToastMessageOptions): void {
        if (!url) {
            return;
        }
        copy.text(url);
        this.messageService.add({
            severity: messageSeverityEnum.success,
            summary: this.localizationService.transform(message?.summary),
            detail: this.localizationService.transform(message?.detail),
        });
        (event.target as HTMLElement)?.focus();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptions = [];
    }
}
